'use strict';

module.exports = function (position, e) {

  var offset = this.perPage;

  var refToEdit = 'R' + position[0] + offset + 'C' + position[1];

  if (this.opts.cellToEdit.indexOf(refToEdit) === -1) this.opts.cellToEdit.push(refToEdit);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/edit-cell.js